import React from "react"
import { GoogleLogin } from "@react-oauth/google"
import { useAuth } from "@/hooks/useAuth"
import { toast } from "@/lib/toast"

interface GoogleSSOButtonProps {
  onSuccess?: () => void
}

const GoogleSSOButton: React.FC<GoogleSSOButtonProps> = ({ onSuccess }) => {
  const { externalLogin } = useAuth()

  return (
    <div className="flex w-full justify-center">
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          if (credentialResponse.credential) {
            try {
              await externalLogin("Google", credentialResponse.credential)
              toast.success("Sesión iniciada con Google")
              if (onSuccess) onSuccess()
            } catch (error: any) {
              toast.error(
                "Error al iniciar sesión con Google: " + (error.message || "Error desconocido")
              )
            }
          }
        }}
        onError={() => {
          toast.error("Error en la autenticación de Google")
        }}
        useOneTap
        theme="outline"
        shape="rectangular"
        width="100%"
      />
    </div>
  )
}

export default GoogleSSOButton

